import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject, NothingHere, toArray } from 'Mri.Web.Common';
import * as React from 'react';
import { BsPhone } from '@react-icons/all-files/bs/BsPhone';
import { RouteComponentProps } from 'react-router';
import { AccountStore } from '../Account/AccountStore';
import { AuditStore } from '../Audit/AuditStore';
import { AppStore } from '../Core/AppStore';
import { DeviceLoginItem } from './DeviceLoginItem';

export interface IDeviceLoginsProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class DeviceLogins extends React.Component<IDeviceLoginsProps> {
    @action
    public async componentDidMount() {
        if (this.accountStore.user) {
            this.loading = true;
            try {
                await this.auditStore.loadUserSessionLog();
            } catch (e: any) {
                this.appStore.setError(e);
            } finally {
                this.loading = false;
            }
        }
    }

    public render() {
        return (
            <div className="container-fluid px-2 px-md-4">
                <div className="row mb-5">
                    <div className="col-12">
                        <h5>Device Sign-ins</h5>
                        View the list of devices that have been used with your SmartVu® account.
                        <hr />
                    </div>
                </div>

                {this.deviceLogins && this.deviceLogins.map((l, k) => <DeviceLoginItem logItem={l} key={k} />)}

                <NothingHere
                    empty={!this.deviceLogins?.length}
                    forceLoaderOnLoad
                    icon={<BsPhone />}
                    loading={this.loading}
                    loadingMessage="Loading..."
                />
            </div>
        );
    }

    @computed
    private get deviceLogins() {
        return this.auditStore.userSessionLog;
    }

    @observable
    private loading = false;
    @inject
    private auditStore!: AuditStore;
    @inject
    private accountStore!: AccountStore;
    @inject
    private appStore!: AppStore;
}
